import React, { useMemo } from 'react'
import { useEntitiesByIds } from 'hamster-react'
import { Offer } from 'cityads-v3/types/offers'

import PaidFormat from 'cityads-v3/components/Format/PaidFormat'

type OfferPaymentsProps = {
  offerId: Offer['id']
}

export default function OfferPayments({ offerId }: OfferPaymentsProps) {
  const ids = useMemo(() => [offerId], [offerId])
  const [, , offers] = useEntitiesByIds('offer', ids)

  return (
    <PaidFormat
      commissionData={offers?.[0]?.commission_data}
    />
  )
}
